import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import {
  deleteTrafficPeriodsMutation,
  saveTrafficPeriodMutation
} from '@app/pcs/data/traffic-period.mutations';
import {
  selectableTrafficPeriodsQuery,
  trafficPeriodQuery,
  trafficPeriodsQuery,
  trafficPeriodTemplateQuery,
  validatePeriodInServiceCodeQuery
} from '@app/pcs/data/traffic-period.queries';
import { TrafficPeriod } from '@app/pcs/models';

@Injectable()
export class TrafficPeriodDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetch(ttpId) {
    return this.graphqlService.query(trafficPeriodsQuery, {ttpId});
  }

  fetchSelectableTrafficPeriods(ttpId) {
    return this.graphqlService.query(selectableTrafficPeriodsQuery, {ttpId});
  }

  fetchTrafficPeriodById(id: number) {
    return this.graphqlService.query(trafficPeriodQuery, {id});
  }

  delete(trafficPeriodIds: number[]) {
    return this.graphqlService.mutation(deleteTrafficPeriodsMutation, {
      trafficPeriodIds
    });
  }

  save(trafficPeriod: TrafficPeriod) {
    return this.graphqlService.mutation(saveTrafficPeriodMutation, {
      trafficPeriod
    });
  }

  fetchTemplate(ttpId) {
    return this.graphqlService.query(trafficPeriodTemplateQuery, {ttpId});
  }

  validatePeriodInServiceCode(trafficPeriod: TrafficPeriod) {
    return this.graphqlService.query(validatePeriodInServiceCodeQuery, {
      trafficPeriod
    }, hideLoader());
  }
}
